import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

import { ReportRoutingModule } from './report-routing.module';
import { ReportComponent } from './report.component';
import { WeekpickerComponent } from './weekpicker/weekpicker.component';
import { ReportCardContentComponent } from './report-card-content/report-card-content.component';
import { ReportSummaryComponent } from './report-summary/report-summary.component';
import { BlankReportComponent } from './blank-report/blank-report.component';

import { ReportService } from './shared';

import { DropdownModule } from './../vision/dropdown/dropdown.module';
import { IconModule } from './../vision/icon/icon.module';

@NgModule({
  imports: [
    SharedModule,
    ReportRoutingModule,
    DropdownModule,
    IconModule
  ],
  declarations: [
    ReportComponent,
    WeekpickerComponent,
    ReportCardContentComponent,
    ReportSummaryComponent,
    BlankReportComponent
  ],
  providers: [
    ReportService
  ]
})
export class ReportModule { }
